export default {
    name: 'countries',
    component: () => import(/* webpackChunkName: "countries-Layout" */ '@/modules/countries/layouts/Layout'),
    children: [
        {
            path: '',
            name: 'dashboard.countries.index',
            component: () => import(/* webpackChunkName: "countries-index" */ '@/modules/countries/views/Index'),
        },
        {
            path: 'create',
            name: 'dashboard.countries.create',
            component: () => import(/* webpackChunkName: "countries-create" */ '@/modules/countries/views/Create'),
        },
        {
            path: ':id/edit',
            name: 'dashboard.countries.edit',
            component: () => import(/* webpackChunkName: "countries-edit" */ '@/modules/countries/views/Edit'),
        },
    ]
}